// extracted by mini-css-extract-plugin
export default {"head":"OrganizationsPage_head__oZNCt","title":"OrganizationsPage_title__xKjsr","spacer":"OrganizationsPage_spacer__g5G6g","empty":"OrganizationsPage_empty__9N5UO"};